// extracted by mini-css-extract-plugin
module.exports = {"atom__status-tag-container":"styles_atom__status-tag-container__VGMXC","attention":"styles_attention__yKrrE","success":"styles_success__H8GRm"};